import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import CurrencyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/currency/currency.entity";
import { IUpdateCurrency } from "./interfaces/update-currency.interface";
import { ICreateCurrency } from "./interfaces/create-currency.interface";

const apiUrl = env.API_UNIT_MEASURE;
const moduleName = "currency";

@Injectable({
  providedIn: "root",
})
export class CurrencyService extends AbstractService<
  CurrencyAttributes,
  ICreateCurrency,
  IUpdateCurrency
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<CurrencyAttributes>, 
  ): Observable<IPaginationResult<CurrencyAttributes>> {
  
    const query = buildQuery<CurrencyAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("code", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),

      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<CurrencyAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<CurrencyAttributes[]>> {
    const query = buildQuery<CurrencyAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["_id","code", "name"]),
      orderBy("code", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<CurrencyAttributes[]>>(API_URL);
  }
}
